










































import Vue from 'vue';
import { mapGetters } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
import pxCard from '@/dex-shared/components/px-card.vue';

export default Vue.extend({
  components: {
    pxCard,
    SquareEditOutlineIcon,
    TrashCanOutlineIcon,
    ArrowRightIcon,
  },

  computed: {
    ...mapGetters({
      classroom: 'currentClassroom',
    }),
  },

  async mounted() {
    let classroomId = parseInt(this.$route.params.classroomId);
    if (!classroomId) classroomId = 6; //TODO landing page
    this.$store.dispatch('PULL_CLASSROOM', classroomId);
  },

  methods: {
    removeBoardsClassroom: async function(boardsClassroomId: number) {
      await this.$store.dispatch('REMOVE_BOARDS_CLASSROOM', boardsClassroomId);
      let classroomId = parseInt(this.$route.params.classroomId);
      if (!classroomId) classroomId = 6; //TODO landing page
      this.$store.dispatch('PULL_CLASSROOM', classroomId);
    },
  },
});
